module.exports = __webpack_public_path__ + "static/don12-3b3feb20eacfe206fe6013c5d674aa78.jpg";